import { config } from '@/config';
import { createApp } from '@shopify/app-bridge';
import { Button, Redirect, TitleBar } from '@shopify/app-bridge/actions';
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

function useTitleBar(options: { title: string; breadcrumbLabel?: string; breadcrumbPath?: string }) {
  const location = useLocation();
  const configApp = useMemo(
    () => ({
      apiKey: process.env.REACT_APP_API_KEY || '',
      host: new URLSearchParams(location.search).get('host') || 'YWRtaW4uc2hvcGlmeS5jb20vc3RvcmUveW91cnNob3AtZGV2',
      forceRedirect: process.env.REACT_APP_MODE === 'live' && config.scope !== 'omegatheme',
    }),
    [location.search],
  );
  const app = useMemo(() => createApp(configApp), [configApp]);

  useEffect(() => {
    if (!app || !options.title) return;

    const { title, breadcrumbLabel, breadcrumbPath } = options;

    let breadcrumb;
    if (breadcrumbLabel && breadcrumbPath) {
      breadcrumb = Button.create(app, {
        label: breadcrumbLabel,
        plain: true,
        disabled: false,
        loading: false,
      });

      breadcrumb.subscribe(Button.Action.CLICK, () => {
        app.dispatch(Redirect.toApp({ path: breadcrumbPath }));
      });
    }

    TitleBar.create(app, {
      title,
      breadcrumbs: breadcrumb,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [app, options.title, options.breadcrumbLabel, options.breadcrumbPath]);
}

export default useTitleBar;
